import { IconPlus } from "@/assets/icons/geist/IconPlus";
import { SetUpDevelopmentEnvironmentModal } from "@/components/ai/SetUpDevelopmentEnvironmentModal";
import { Button } from "@/components/flexkit/Button";
import { useState, type FC } from "react";

export const OnaActions: FC = () => {
    return (
        <div data-testid="ona-actions" className="flex gap-6">
            <CreateProjectButton />
        </div>
    );
};

const CreateProjectButton: FC = () => {
    const [showSetUpModal, setShowSetUpModal] = useState(false);
    return (
        <>
            <Button
                data-testid="ona-create-project-button"
                variant="secondary"
                LeadingIcon={IconPlus}
                onClick={() => setShowSetUpModal(true)}
            >
                Set up development environment
            </Button>

            <SetUpDevelopmentEnvironmentModal open={showSetUpModal} onClose={() => setShowSetUpModal(false)} />
        </>
    );
};
